import { createPatch } from "diff"

/**
 * Provider edit/write payloads carry file fragments that usually do not end
 * with a newline. Diffing those directly emits `\ No newline at end of file`
 * in the middle of a hunk, which is not a valid patch: the parser strips the
 * preceding line's break, so the renderer's line entries no longer match the
 * content it highlights and out-of-range decorations crash the diff view.
 * Terminating both sides keeps the patch line-oriented.
 */
export function createToolPatch(filePath: string, before: string, after: string): string {
    return createPatch(filePath, lineTerminated(before), lineTerminated(after), "", "")
}

function lineTerminated(contents: string): string {
    if (contents === "" || contents.endsWith("\n")) return contents
    return `${contents}\n`
}
